export default __webpack_public_path__ + "static/media/fraseEN.0e35b102.png";